// Mock data for Berkeley IT Services

export const services = [
  {
    id: 1,
    title: "Standard PC Build",
    price: "$165",
    description: "Professional assembly with your parts",
    features: [
      "Professional assembly using customer supplied parts",
      "BIOS update and proper configuration",
      "Windows installation if provided",
      "All drivers installed and verified",
      "Full system stress testing",
      "System ready to use"
    ],
    popular: true
  },
  {
    id: 2,
    title: "Custom Builds",
    price: "Quote",
    description: "High-end & specialty systems",
    features: [
      "High end gaming systems",
      "Workstation builds",
      "Specialty or unique configurations",
      "Custom water cooling",
      "RGB and aesthetic customization",
      "Performance optimization"
    ],
    popular: false
  },
  {
    id: 3,
    title: "Repair & Support",
    price: "From $40",
    description: "Expert diagnostics and repairs",
    features: [
      "Diagnostics - $40 (applied to repair if approved)",
      "General repairs - $75/hour",
      "Troubleshooting and optimization",
      "Data transfer - $50-$100",
      "Backup services",
      "Pickup/Delivery - $30 local"
    ],
    popular: false
  }
];

export const portfolioItems = [
  {
    id: 1,
    title: "High-End Gaming Build",
    specs: "RTX 4090, i9-13900K, 64GB RAM",
    image: "https://images.unsplash.com/photo-1587202372634-32705e3bf49c?w=800",
    category: "Gaming"
  },
  {
    id: 2,
    title: "Professional Workstation",
    specs: "RTX 4080, Ryzen 9 7950X, 128GB RAM",
    image: "https://images.unsplash.com/photo-1591799264318-7e6ef8ddb7ea?w=800",
    category: "Workstation"
  },
  {
    id: 3,
    title: "Custom Water-Cooled PC",
    specs: "RTX 4080, i7-13700K, Custom Loop",
    image: "https://images.unsplash.com/photo-1580584126903-c17d41830450?w=800",
    category: "Custom"
  },
  {
    id: 4,
    title: "Compact ITX Build",
    specs: "RTX 4070, Ryzen 7 7800X3D",
    image: "https://images.unsplash.com/photo-1600861194942-f883de0dfe96?w=800",
    category: "Compact"
  },
  {
    id: 5,
    title: "RGB Gaming Setup",
    specs: "RTX 4070 Ti, i5-13600K",
    image: "https://images.unsplash.com/photo-1593640408182-31c70c8268f5?w=800",
    category: "Gaming"
  },
  {
    id: 6,
    title: "Budget-Friendly Build",
    specs: "RTX 4060, Ryzen 5 7600",
    image: "https://images.unsplash.com/photo-1573164713988-8665fc963095?w=800",
    category: "Budget"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How long does a standard PC build take?",
    answer: "Most standard builds are completed within 1-2 business days from the time I receive all parts. Complex custom builds may take 3-5 days depending on the configuration and testing requirements."
  },
  {
    id: 2,
    question: "Do I need to provide all the parts?",
    answer: "For the $165 standard build service, yes, you provide the parts. However, I can help you source components for custom builds and provide recommendations based on your needs and budget."
  },
  {
    id: 3,
    question: "What's included in the diagnostics service?",
    answer: "The $40 diagnostic service includes a thorough examination of your system to identify hardware or software issues. This fee is applied toward the repair cost if you approve the work."
  },
  {
    id: 4,
    question: "Do you offer pickup and delivery?",
    answer: "Yes! I offer local pickup and delivery for $30 within the Jackson, TN area. This makes it convenient if you can't drop off your system yourself."
  },
  {
    id: 5,
    question: "What if something goes wrong after the build?",
    answer: "I stand behind my work. If you experience any issues related to the assembly or configuration, contact me immediately and I'll make it right at no additional charge."
  },
  {
    id: 6,
    question: "Can you help me choose parts for my build?",
    answer: "Absolutely! Message me on Facebook with your budget and intended use (gaming, work, content creation, etc.) and I'll provide recommendations for a balanced, compatible system."
  },
  {
    id: 7,
    question: "Do you work on laptops?",
    answer: "I primarily focus on desktop PC builds and repairs. For laptop issues, contact me to discuss your specific needs and I'll let you know if I can help."
  },
  {
    id: 8,
    question: "What payment methods do you accept?",
    answer: "I accept PayPal, cash, and cashier's check. Payment is due upon completion of service."
  }
];

export const valueProps = [
  {
    id: 1,
    icon: "Home",
    title: "Local Home-Based Service",
    description: "Personalized attention from a local business you can trust, not a corporate chain."
  },
  {
    id: 2,
    icon: "MessageCircle",
    title: "Honest Advice",
    description: "I'll tell you what you need, not what makes the most money. Your satisfaction is my priority."
  },
  {
    id: 3,
    icon: "Award",
    title: "Quality Workmanship",
    description: "Meticulous attention to detail and thorough testing ensure your system runs perfectly."
  },
  {
    id: 4,
    icon: "Wrench",
    title: "Built the Right Way",
    description: "Proper cable management, optimal airflow, and correct configurations from the start."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Mike Rodriguez",
    rating: 5,
    text: "Outstanding service! Built my gaming PC exactly to spec and it runs like a dream. Worth every penny.",
    date: "2 weeks ago"
  },
  {
    id: 2,
    name: "Sarah Chen",
    rating: 5,
    text: "Fixed my computer issue quickly and explained everything clearly. Very honest and fair pricing.",
    date: "1 month ago"
  },
  {
    id: 3,
    name: "David Thompson",
    rating: 5,
    text: "The custom build they created for my video editing work is incredible. Great communication throughout.",
    date: "3 weeks ago"
  }
];